// extracted by mini-css-extract-plugin
module.exports = {"text-input":"text-input-jR2Nr"};